<template>
  <div id="personal">
<!--    <yy-header>预约记录</yy-header>-->
    <div class="main">
      <div class="filtrate">
        <span @click="selectStatus('已预约')" :class='state  === "已预约" ? "active" : ""'>已预约</span>
        <span @click="selectStatus('已取消')" :class='state  === "已取消" ? "active" : ""'>已取消</span>
        <span @click="selectStatus('已完成')" :class='state  === "已完成" ? "active" : ""'>已完成</span>
        <span @click="selectStatus('已过期')" :class='state  === "已过期" ? "active" : ""'>已过期</span>
        <span @click="selectStatus('历史')" :class='state  === "历史" ? "active" : ""'>历史</span>
      </div>
      <div class="tip" v-if="list.length===0">暂无数据</div>
      <ul class="listContent">
      <van-list
        class="item"
        v-model="loading"
        :finished="finished"
        finished-text="今日之前的预约记录请到历史中查看"
        @load="onLoad"
      >
        <li v-for="(item,index) in list" :key="index" class='list_item'>
          <div class='item-title clearfix'>
            <span class='item-name'><span style="color: #CBB486" v-show="item.tag!=undefined">【虚窗帮办】</span>{{item.termName}}<div v-show="item.userType==='TRUSTEE'" class="daiImg"><img src="../assets/img/dai.png" alt=""></div></span>
            <span v-show="item.status === '有效'" @click="cancel(item.recordId,item.source,item.organType,item.proxy)" class='item-state'>取消预约</span>
          </div>
          <div class="item-content">
            <img v-show="item.status === '有效'" src="../assets/img/success.png" alt="">
            <!-- <p>
              <span>预约编号：</span>
              <span class="record-id">{{item.recordId}}</span>
            </p> -->
            <p>
              <span>办理地点：</span>
              <span>{{item.placeName}}</span>

            </p>
            <p>
              <span>预约时间：</span>
              <span>{{item.reservationTime}}</span>
<!--              {{item.periodStart}}~{{item.periodEnd}}-->
            </p>
            <p>
              <span>预约状态：</span>
              <span v-show="item.status === '有效'">预约成功
              </span>
              <span v-show="item.status === '已取消'">已取消</span>
              <span v-show="item.status === '已到场'">已完成</span>
              <span v-show="item.status === '已过期'">已过期</span>
            </p>
            <p v-show="item.userType==='TRUSTEE'">
              <span>授权委托单位名称：</span>
              <span>{{item.stCorpName}}</span>
            </p>
            <p v-show="item.userType==='TRUSTEE'">
              <span>统一社会信用代码：</span>
              <span>{{item.stCorpCreditCode}}</span>
            </p>
            <p>
                <button style="background: linear-gradient(to right,#e4c995,#b9916a);color: #fff;width:  3.375rem;margin-left: 37%;border-radius: 10px;text-align: center;margin-top: 15px;"  v-show="item.status === '有效'&&item.takeNoOnline === '1' &&(item.stTakeNum ===''||item.stTakeNum===null||item.stTakeNum===undefined||item.stTakeNum==='null'||item.stTakeNum==='undefined') "   @click="getOnloneNum(item.recordId,item.stPlaceId,item.stTakeNum,item.stTakeTime,item.taketips,item.termName,item.reservationTime,item.waitCnt,item.acceptArea)">
                取&nbsp;&nbsp;号
                </button>
            </p>
            <p v-show="item.status === '已到场'&&item.stTakeNum !=''&&item.stTakeNum!=null&item.stTakeNum!=undefined&&item.stTakeNum!='null'&&item.stTakeNum!='undefined' " >
              <span>您的号码：</span>
              <span      >{{item.stTakeNum}} 号 <span style="font-size: 0.56rem;color: #555;" v-show="item.acceptArea !=''&&item.acceptArea!=null&item.acceptArea!=undefined&&item.acceptArea!='null'&&item.acceptArea!='undefined'"> (您可在{{item.acceptArea}}号窗口办理业务)</span></span>

            </p>

<!--            <p v-show="item.status !== '过期'">-->
<!--              <span v-show="item.status === '有效'">操作时间：</span>-->
<!--              <span class="fc-9" v-show="item.status === '取消'">取消时间：</span>-->
<!--              <span class="fc-9" v-show="item.status === '到场'">到场时间：</span>-->
<!--              <span>{{ item.reservationTime }}</span>-->
<!--            </p>-->
            <p v-show="item.proxy&&item.proxy!=='DENY'&&item.proxy!=='undefined'&&item.proxy!=='null'">
              <span>代约人数：</span>
              <span >{{item.proxyNumber}}人 <a v-show="item.proxy==='REAL_NAME'&& item.proxyList.length>0" style="color: #cfba90;padding-left: 10px" @click="showDetails(index)">详情</a></span>
<!--              <span v-show="item.proxyNumber<0"> 0人 <a v-show="item.proxy==='REAL_NAME'" style="color: #cfba90;padding-left: 10px" @click="showDetails(index)">详情</a></span>-->
            </p>
          </div>

          <div class='item-title clearfix' >
            <transition-group name="fade"  tag="div">
            <div v-for="(itempl,indexB) in item.proxyList"  v-bind:key="itempl.stIdCardNo" v-show="index === authIndex" style="padding-bottom: 5px;">
              <p>
                <span>姓名: </span>
                <span>{{itempl.stUsername}}</span>
              </p>
              <p>
                <span>身份证号: </span>
                <span>{{mobileStrIdCard(itempl.stIdCardNo)}} <a v-show="itempl.stStatus==='有效'" style="color: #cfba90;float: right" @click="cancel(itempl.stRecordId,itempl.stSource,itempl.stOrganType,itempl.proxy)">取消预约</a> <span v-show="itempl.stStatus!=='有效'" style="color: #aaaaaa;float: right">已取消</span></span>
              </p>
              <p>
                <span>手机号: </span>
                <span>{{mobileStrPhone(itempl.stMobile)}}</span>
              </p>
            </div>
            </transition-group>

            <div style="text-align: center">
              <transition name="fade">
                <span @click="showDetails(-1)" v-show="index === authIndex" style="color: #cbb486;font-size: 14px">收起<van-icon name="arrow-up" size="14px" /></span>
              </transition>
            </div>

          </div>
        </li>

<!--        <van-card v-show="showIdCadList">-->
<!--          <div slot="desc"  >-->
<!--            <van-list  class="reservation-list" style="padding-right: 0.6rem;padding-top: 0.3rem;">-->
<!--        <li   v-for="item in proxyList" :key="item.index" style=" display: flex;justify-content: space-around;align-items:center;background-color:#F8F4EC ;border-style:solid;border-width:3px;border-color: white;height: 50px;">-->
<!--          <span><van-icon name="idcard" size="21px" style="padding-top: 0.2rem"></van-icon></span>-->
<!--          <span class="matter">{{item.name}}</span>-->
<!--          <div>-->
<!--            <p class="matter">证件号:{{ mobileStrIdCard(item.idCard)}} </p>-->
<!--            <p class="matter">手机号: {{mobileStrPhone(item.mobile) }}</p>-->
<!--          </div>-->
          <!--            <span @click="delIdCard(item.idCard)" ><van-icon name="clear" size="23px" style="padding-top: 0.2rem"/></span>-->
<!--        </li>-->
<!--      </van-list>-->
<!--          </div>-->
<!--        </van-card>-->
      </van-list>
      </ul>

<!--      <van-popup-->
<!--        v-model="showIdCadList"-->
<!--        position="bottom"-->
<!--        :style="{ height: '30%' }"-->
<!--      >-->
<!--        <van-list  class="reservation-list" style="padding-right: 0.6rem;padding-top: 0.3rem;">-->
<!--          <li   v-for="item in proxyList" :key="item.index" style=" display: flex;justify-content: space-around;align-items:center;background-color:#F8F4EC ;border-style:solid;border-width:3px;border-color: white;height: 50px;">-->
<!--            <span><van-icon name="idcard" size="21px" style="padding-top: 0.2rem"></van-icon></span>-->
<!--            <span class="matter">{{item.name}}</span>-->
<!--            <div>-->
<!--              <p class="matter">证件号:{{ mobileStrIdCard(item.idCard)}} </p>-->
<!--              <p class="matter">手机号: {{mobileStrPhone(item.mobile) }}</p>-->
<!--            </div>-->
<!--&lt;!&ndash;            <span @click="delIdCard(item.idCard)" ><van-icon name="clear" size="23px" style="padding-top: 0.2rem"/></span>&ndash;&gt;-->
<!--          </li>-->
<!--        </van-list>-->
<!--      </van-popup>-->
<!--      <div class="tip" v-if="list.length===0">暂无数据</div>-->
    </div>
    <van-dialog v-model="showNotice" title="在线取号" theme='round-button'  confirm-button-color="white">
      <div style="height: 15rem;overflow:auto;">
        <div >
          <br>
          <p style="text-indent:2em;margin-left: 3%;"  ><span  style=" text-align: center;width: 100% ;margin-left: 30%; font-size: 35px"  >{{this.stTakeNum}} </span> 号</p>
          <br>
          <p v-if="this.waitCnt!=''&&this.waitCnt!=null&&this.waitCnt!='null'  &&this.waitCnt!=undefined&&this.waitCnt!='undefined'" style="text-indent:2em;margin-left: 3%;"  > <label >等待人数</label> : <span style=" text-align: center;width: 100% ;">{{this.waitCnt}}</span> </p>
          <p v-else style="text-indent:2em;margin-left: 3%;"  > <label >等待人数</label> : <span style=" text-align: center;width: 100% ;">--</span> </p>
          <br>
          <p v-if="this.acceptArea!=''&&this.acceptArea!=null&&this.acceptArea!='null'  &&this.acceptArea!=undefined&&this.acceptArea!='undefined'"  style="text-indent:2em;margin-left: 3%;"  > <label >受理窗口</label> : <span style=" text-align: center;width: 100% ;">{{this.acceptArea}}</span> </p>
          <p v-else style="text-indent:2em;margin-left: 3%;"  > <label >受理窗口</label> : <span style=" text-align: center;width: 100% ;">--</span> </p>

          <br>
          <p style="text-indent:2em;margin-left: 3%;"  > <label >事项名称</label> : <span style=" text-align: center;width: 100% ;">{{this.tempTermname}}</span> </p>

          <br>
          <p style="text-indent:2em;margin-left: 3%;"  > <label >预约时间</label> : <span style=" text-align: center;width: 100% ;">{{this.tempTermDate}}</span> </p>
          <br>
          <p style="text-indent:2em;margin-left: 3%;"  > <label >取号时间</label> : <span style=" text-align: center;width: 100% ;">{{this.stTakeTime}}</span> </p>
          <br>

          <br>

        </div></div>
    </van-dialog>
  </div>
</template>

<script>
import { mobileStrIdCardUp, mobileStrPhoneUp } from '../utils/coverUp'
import {isEmpty} from "../utils";

export default {
  data () {
    return {
      authIndex: -1,
      showIdCadList: false,
      proxy: 'NON_REAL_NAME',
      proxyauth: true,
      list: [],
      status: '',
      state: '已预约',
      reservationTime: this.reservationTime,
      recordId: '',
      placeName: this.placeName,
      termName: this.termName,
      loading: false,
      finished: true,
      total: 0,
      current: 0,
      size: 5,
      cur: 2,
      idcard: this.idcard,
      pageNum: '',
      pageSize: '',
      showNotice:false,
      stTakeNum:'',
      stTakeTime:'',
      tempTermname:'',
      tempTermDate:'',
      waitCnt:'',
      acceptArea:''
    }

  },
  methods: {
    mobileStrIdCard (str) {
      return mobileStrIdCardUp(str)
    },
    mobileStrPhone (str) {
      return mobileStrPhoneUp(str)
    },
    showDetails (index) {
      this.authIndex = index
      this.showIdCadList = !this.showIdCadList
    },
    getUserInfoByToken: async function () {
      try {
        const res = await this.$axios.post('/forwarder/login/getUserInfoByToken', {
          access_token: this.access_token
        })
        if (res.status === '200') {
          sessionStorage.setItem('idCardNo', res.idCardNo)
          sessionStorage.setItem('mobile', res.mobile)
          sessionStorage.setItem('userName', res.userName)
        }
      } catch (e) {
        this.$toast('用户信息获取失败')
      }
    },
    jumpToMobile: function () {
      window.location.href = '/forwarder/redirect/jumpToMobile'
    },
    async getLogList () {
      try {
        this.idcard = sessionStorage.getItem('idCardNo')
        if (this.idcard === null || this.idcard === undefined || this.idcard === '' || this.idcard === 'null') {
          this.$toast('请稍后再试')
          this.loading = false
          return
        }
        const res = await this.$axios.post('/dev/AppFController/getMyRecordList', {
          state: this.state,
          pageSize: this.size,
          pageNum: this.current
        })
        this.termName = res.termName
        this.placeName = res.placeName
        this.reservationTime = res.reservationTime
        this.recordId = res.recordId
        if (res.status === '200') {
          this.list = [...this.list, ...(res.data ? res.data : [])]
          this.total = res.total
          this.loading = false
          this.cur = Math.ceil(this.total / this.size)
          if (this.list.length === this.total) {
            this.finished = true
          }
        } else {
          this.$toast(res.msg)
        }
      } catch (e) {
        this.$toast('获取记录失败')
      }
    },
    async onLoad () {
      setTimeout(() => {
        this.loading = true
        if (this.current <= this.cur) {
          this.current += 1
        } else {
          // 数据全部加载完成
          this.finished = true
          return
        }
        this.getLogList()
      }, 500)
    },
    toNoTermForServicePage () {
      this.$router.push({
        path: '/noTermForService',
        query: {
        }
      })
    },
    async cancel (recordId, source, organType, proxy) {
      try {
        this.$dialog.confirm({
          title: '温馨提示',
          message: '确定要取消预约吗？'
        }).then(async () => {
          if (source === '0099') {
            let url = ''
            if (organType === '社区') { // 社区取消
              url = 'https://zwdt.sh.gov.cn/zwdtSW/zwdt/Yuyue/cance.do?reservationId=' + recordId
            } else { // 市、区取消
              url = 'http://zwdt.sh.gov.cn/zwdtSW/gxhpt/qxyyf.do?type=old&appointmentId=' + recordId
            }
            window.location.href = url
          } else {
            const res = await this.$axios.post('/dev/AppUController/saveRecordCancel', {
              proxy: proxy,
              recordId: recordId
            })
            if (res.status === 200) {
              this.$toast('取消预约成功')
              this.list = []
              this.current = 1
              this.getLogList()
            } else {
              this.$toast(res.msg)
            }
          }
        }).catch(() => {
          // this.$toast('已取消')
        })
      } catch (e) {
        this.$toast('取消预约失败')
      }
    },
    async getOnloneNum (recordId, stItemId,stTakeNum,stTakeTime ,taketips,termName,reservationTime,waitCnt,acceptArea) {
     let arr= reservationTime.split("-")
      let dayarr=arr[2].split(" ")
      let day=new Date().getDate();
     // if(dayarr[0]!=day){
     //   this.$toast("请在当天预约");
     //   return;
     // }

      if (taketips == null || taketips=='' || taketips=='null' || taketips==undefined  || taketips=='undefined' ){
        taketips="请确认是否预约取号";
      }
      try {
        this.$dialog.confirm({
          title: '温馨提示',
          message: taketips
        }).then(async () => {
          if (stTakeNum == null || stTakeNum=='' || stTakeNum=='null' || stTakeNum==undefined  || stTakeNum=='undefined' ){
            try {
              const res = await this.$axios.post('/dev/AppFController/takeNumOnline', {
                stPlaceId: stItemId,
                recordId: recordId,
                reservationTime:reservationTime
              })
              if (res.status ==200) {
                let data=res.data;
                if (data.onlinetype === 'PAGE') {
                  if("stIdCardNo"===data.stParams){
                    window.location.href = data.stOnlineUrl + '?' + data.stParams + '=' + recordId+'&publicKey='+data.publicKey
                  }else {
                    window.location.href = data.stOnlineUrl + '?' + data.stParams + '=' + recordId
                  }
                } else {
                  this.tempTermname= termName;
                  this.tempTermDate=reservationTime;
                  this.stTakeNum=data.stTakeNum;
                  this.stTakeTime=data.stTakeTime;
                  this.waitCnt=data.waitCnt;
                  this.acceptArea=data.acceptArea;
                  this.showNotice=true;
                  this.selectStatus('已完成')
                }
              } else  {
                if(res.msg==''||res.msg==null||res.msg=='null'){
                  this.$toast("取号失败,请现场取号！")
                }else {
                  this.$toast(res.msg)
                }

              }
            } catch (e) {
              this.$toast('失败')
            }
          }else {
            this.tempTermname= termName;
            this.tempTermDate=reservationTime;
            this.waitCnt= waitCnt;
           this.acceptArea= acceptArea;
            this.stTakeNum=stTakeNum;
            this.stTakeTime=stTakeTime;
            this.showNotice=true;
          }
        }).catch(() => {
           this.$toast('已取消')
        })
      } catch (e) {
        this.$toast('取消失败')
      }
    },
    selectStatus (status) {
      this.authIndex = -1
      this.state = status
      this.list = []
      this.finished = false
      this.current = 1
      this.getLogList()
    },
    async getUserInfoByAppToken() {
      try {
        const res = await this.$axios.post('/forwarder/enterprise/getUserInfoByAppToken', {
          appToken: this.app_token
        })
        if (res.status === '200') {
          this.idcard = res.data.idCard
          this.mobile = res.data.phone
          this.name = res.data.realName
          sessionStorage.setItem('idCardNo', res.data.idCard)
          sessionStorage.setItem('mobile', res.data.phone)
          sessionStorage.setItem('userName', res.data.realName)
        }
      } catch (e) {
        console.log('企业获取用户信息失败')
      }
    }
  },
  async created () {
    document.title = '预约记录'
    this.mobile = sessionStorage.getItem('mobile')
    this.name = sessionStorage.getItem('userName')
    this.idcard = sessionStorage.getItem('idCardNo')
    if (this.$route.query.access_token) {
      this.access_token = this.$route.query.access_token
    }
    if (this.$route.query.reference) {
      this.reference = this.$route.query.reference
      sessionStorage.setItem('reference', this.$route.query.reference)
    }else if(sessionStorage.getItem('reference')){
      this.reference = sessionStorage.getItem('reference')
    }
    if(this.reference!=="enterprise"){
      await this.getUserInfoByToken()
    }
    if (this.reference === 'enterprise'  && isEmpty(this.idcard)) {
      if (!isEmpty(sessionStorage.getItem('app_token')) || !isEmpty(this.$route.query["app-token"])) {
        if (!isEmpty(sessionStorage.getItem('app_token'))) {
          this.app_token = sessionStorage.getItem('app_token')
        }
        if (!isEmpty(this.$route.query["app-token"])) {
          this.app_token = this.$route.query["app-token"]
        }
        await this.getUserInfoByAppToken()
      } else {
        //jumpToEnterpriseLogin
        this.$toast('用户信息获取失败')
      }
    }
    // alert(this.idcard)
    if (this.idcard === null || this.idcard === undefined || this.idcard === '' || this.idcard === 'null') {
      console.log('! idcard')
      if (this.access_token !== undefined && this.access_token !== null && this.access_token !== '') {
        await this.getUserInfoByToken()
      } else {
        if(this.reference ==="enterprise"){
          this.$toast('用户信息获取失败')
          //jumpToEnterpriseLogin
          return
        }else {
          this.jumpToMobile()
          return
        }

      }
    }
    this.finished = false
  }
}
</script>

<style  lang="less">
#personal{
  .main{
    padding-bottom: 0;
  }
}

.filtrate{
  top:0rem;
  background:#fff;
  display:flex;
  font-size:.64rem /* 32/50 */;
  color:#999999;
  justify-content:space-around;
  font-weight:bold;
  position:fixed;
  width:100%;
  padding: .48rem /* 24/50 */;
  z-index:1000;

  span{
    padding: 0 .48rem /* 24/50 */;
    font-size: .48rem /* 24/50 */;
    height: .84rem /* 42/50 */;
    line-height: .84rem /* 42/50 */;
  }
  span.active{
    color:@theme-color;
    background-color: #faf7f3;
    border-radius: 20px;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-enter-active .dialog-main, .fade-leave-active .dialog-main{
  transition: height .5s linear;
}
.fade-enter .dialog-main, .fade-leave-to .dialog-main  {
  height: 0;
}
.listContent{
  margin-top: -0.7rem /* 60/50 */;
  .list_item{
    padding: .4rem /* 20/50 */ 0;
    border-bottom: .02rem /* 1/50 */ solid #e5e5e5;
    .item-title{
      padding: 0 .6rem /* 30/50 */;
      background:#fff;
      // border-bottom:.04rem /* 2/50 */ solid #efefef;
      .item-name{
        font-size:.72rem /* 36/50 */;
        font-weight: 700;
        color:#333;
        float: left;
      }
      .item-state{
        float:right;
        font-size:.56rem /* 28/50 */;
        color:@theme-color;
        margin-top:5px;
      }
    }
    .item-content{
      background:#fff;
      padding:.3rem /* 15/50 */ .6rem /* 30/50 */;
      font-size:.56rem /* 28/50 */;
      line-height:1rem /* 50/50 */;
      color:#555;
      position:relative;
      img{
        position:absolute;
        width:2.76rem /* 138/50 */;
        height:2.76rem /* 138/50 */;
        right:.6rem /* 30/50 */;
        top:50%;
        margin-top:-1.38rem /* 69/50 */;
      }
    }
    .item-content p span:first-child{
      color:#999999;
    }
    .item-content p span.fc-9 {
      color: #999;
    }
  }
}
.tip {
  width: 100%;
  margin-top: 4rem /* 200/50 */;
  line-height: 4rem /* 100/50 */;
  font-size: .48rem /* 24/50 */;
  text-align:center ;
  color: #aaa;
}
.van-list__error-text, .van-list__finished-text, .van-list__loading {
  font-size:13px!important
}
.van-dialog__confirm, .van-dialog__confirm:active {
  color: @theme-color !important;
}

.daiImg {
  height: 1rem;
  width: 1rem;
  margin-top: 0.1rem;
  float: right;
  margin-left: 8px
}
</style>
